import { IComboBoxStyles, ITheme } from '@fluentui/react';
import { Theme } from '../../Models/Constants/Enums';

/* 
    Fluent UI Combobox component hover state is not working properly in dark theme, 
    therefore overriding styles using semantic colors for it as below. Although the selected
    colors are not very ideal use case for combobox, since currently css vars of cardboard-app-data-theme 
    cannot be accessed from root layer combobox menu callout, I used most semantically closed colors to override.
*/
export const getComboBoxStyles = (
    themeSetting: Theme,
    theme: ITheme
): Partial<IComboBoxStyles> => {
    return {
        ...(themeSetting === Theme.Dark && {
            optionsContainer: {
                selectors: {
                    'button:hover': {
                        backgroundColor: `${theme.semanticColors.listItemBackgroundHovered} !important`
                    },
                    'button.is-checked': {
                        backgroundColor: `${theme.semanticColors.listItemBackgroundChecked} !important`
                    }
                }
            }
        })
    };
};
